import { Link } from 'react-router-dom';
import { dramaInfo } from '@/mocks/siteData';

const metaItems = [
  { label: '年份', value: dramaInfo.meta.year },
  { label: '地区', value: dramaInfo.meta.region },
  { label: '类型', value: dramaInfo.meta.genre },
  { label: '集数', value: dramaInfo.meta.totalEpisodes },
  { label: '状态', value: dramaInfo.meta.status },
];

export default function PlotSummary() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
        <div className="w-full lg:flex-1">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              剧情简介
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-loose mb-6">
            {dramaInfo.intro}
          </p>
          <Link
            to="/category/plot"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览全部剧集
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="w-full lg:w-[360px] shrink-0 bg-background-100 border border-background-200 rounded-lg p-6">
          <div className="flex items-center justify-between mb-5">
            <h3 className="font-heading font-semibold text-foreground-950 text-lg">剧集信息</h3>
            <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100">
              <i className="ri-star-fill text-accent-600 w-4 h-4 flex items-center justify-center"></i>
              <span className="text-accent-800 font-semibold text-sm">{dramaInfo.meta.rating}</span>
            </div>
          </div>
          <dl className="space-y-3.5">
            {metaItems.map((item) => (
              <div key={item.label} className="flex items-start justify-between gap-4">
                <dt className="text-sm text-foreground-500 shrink-0">{item.label}</dt>
                <dd className="text-sm text-foreground-900 font-medium text-right">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}